import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
import building from '@/view/console/area/building/building';
import floor from '@/view/console/area/floor/floor';
import device from '@/view/console/device/device';
import alert from '@/view/console/alert/alertItem';
import maintenance from '@/view/console/maintenance/maintenanceItem';
export default {
  data: function data() {
    return {
      currTab: null,
      reducehe: 90,
      pageListResult: [],
      pageList: [{
        title: '防制区域',
        name: 'building'
      }, // {
      //   title:'楼层管理',
      //   name:'floor'
      // },
      {
        title: '设备管理',
        name: 'device'
      }, {
        title: '报警管理',
        name: 'alert'
      }, {
        title: '维保管理',
        name: 'maintenance'
      }]
    };
  },
  components: {
    building: building,
    floor: floor,
    device: device,
    alert: alert,
    maintenance: maintenance
  },
  watch: {
    '$route': function $route(to, from) {
      this.init();
    }
  },
  methods: {
    checkoutAuth: function checkoutAuth() {
      this.pageListResult.splice(0);
      var routesMenu = sessionStorage.getItem('routesMenu');

      if (routesMenu) {
        var arr = JSON.parse(routesMenu);

        for (var i = 0; i < this.pageList.length; i++) {
          var list = this.pageList[i];

          for (var j = 0; j < arr.length; j++) {
            var item = arr[j];
            var itemName = '';

            if (item.route.indexOf('/') > -1) {
              itemName = item.route.split('/')[1];
            } else {
              itemName = item.route;
            }

            if (list.name === itemName) {
              this.pageListResult.push(list);
              break;
            } else if (item.children_menu && item.children_menu.length > 0) {
              for (var k = 0; k < item.children_menu.length; k++) {
                var item2 = item.children_menu[k];
                var _itemName = '';

                if (item2.route.indexOf('/') > -1) {
                  _itemName = item2.route.split('/')[1];
                } else {
                  _itemName = item2.route;
                }

                if (list.name === _itemName) {
                  this.pageListResult.push(list);
                  break;
                } else {}
              }
            }
          }
        }
      }
    },
    tabsClick: function tabsClick(name) {
      var _this = this;

      this.$nextTick(function () {
        debugger;

        _this.$refs[name][0].init();
      });
    },
    init: function init() {
      var params = this.$route.params;
      this.code = params.code;
      this.name = params.name;
      this.checkoutAuth();

      if (this.pageList.length > 0) {
        this.tabsClick(this.pageList[0].name);
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
};